import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import {
  SUBMIT_CHOOSE_ORG_SUCCESS,
  SUBMIT_CHOOSE_ORG_FAILURE,
  DISPLAY_ORGANIZATIONS,
  LOADING_ORGANIZATIONS,
  ORGANIZATION_ERROR,
  NO_ORGANIZATIONS,
} from './types';

export const submitChooseOrg = (formData) => (
  (dispatch) => {
    const { dept, REM_ORG } = formData;
    const corId = `atp-${uuidv4()}`;
    dispatch({
      type: LOADING_ORGANIZATIONS,
      payload: dept,
    });
    return axios({
      url: '/user/chooseorg/api/submit',
      method: 'POST',
      headers: {
        'X-SDFE-CORR-ID': corId,
      },
      data: {
        dept,
        rememberOrg: REM_ORG,
      },
    })
      .then((response) => dispatch({
        type: SUBMIT_CHOOSE_ORG_SUCCESS,
        payload: response.data,
      }))
      .catch((err) => dispatch({
        type: SUBMIT_CHOOSE_ORG_FAILURE,
        payload: err,
      }));
  }
);

export const displayOrganizations = () => (
  (dispatch) => {
    dispatch({ type: LOADING_ORGANIZATIONS });
    const corId = `atp-${uuidv4()}`;
    return axios({
      url: '/user/chooseorg/api/start',
      method: 'get',
      headers: {
        'X-SDFE-CORR-ID': corId,
      },
    })
      .then((response) => dispatch({
        type: DISPLAY_ORGANIZATIONS,
        payload: response.data.organizations,
      }))
      .catch((err) => {
        if (err.response.data && err.response.data.status === 'NO_ORGANIZATIONS') {
          return dispatch({ type: NO_ORGANIZATIONS });
        }
        return dispatch({ type: ORGANIZATION_ERROR });
      });
  }
);

export const initializeOrganizations = (organizationResult) => {
  let dispatchType = { type: LOADING_ORGANIZATIONS };
  if (organizationResult.status === 'CHOOSE_ORG_REQUIRED') {
    dispatchType = {
      type: DISPLAY_ORGANIZATIONS,
      payload: organizationResult.organizations,
    };
  } else if (organizationResult.status === 'NO_ORGANIZATIONS') {
    dispatchType = { type: NO_ORGANIZATIONS };
  }
  return (dispatch) => dispatch(dispatchType);
};
